/* eslint-disable */
import axios from 'axios';

const request = axios.create({
    baseURL: 'https://api-adresse.data.gouv.fr',
    timeout: 10000, // Request timeout
});


class AdressesGouv {
  search(query) {
    return request({
      url: '/search',
      method: 'get',
      params: query,
    });
  }
}

export { AdressesGouv as default };
